"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DataQualityStyles_1 = require("../style/DataQualityStyles");
var DataQualityDetail_1 = require("./DataQualityDetail");
function DataQualityDetailGroup(props) {
    if (props.details.length > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(DataQualityStyles_1.DataQualityDetailGroupHeadingDiv, null, props.message),
            React.createElement(DataQualityStyles_1.DataQualityDetailGroupDiv, null, props.details.map(function (detail, index, _) { return (React.createElement(DataQualityDetail_1.DataQualityDetail, __assign({ key: props.keyPrefix + index.toString() }, detail, { linksDisabled: props.linksDisabled }))); }))));
    }
    return null;
}
exports.DataQualityDetailGroup = DataQualityDetailGroup;
//# sourceMappingURL=DataQualityDetailGroup.js.map